<template>
  <div>
    <jd-form :form-info="myFormInfo" @search="search" :emitReset="true" ref="searchFormRef"
      @reset="(val) => search(val, 'reset')">
    </jd-form>

    <div class="flex-between mt16 mb12">
      <div>
        <jd-button @click="addCrowd" :disabled="tableData.length <= 0">按查询结果生成人群</jd-button>
        <jd-button :disabled="selectIds.length == 0 || isDrawTime" @click="batchAuditPass">批量审核通过</jd-button>
        <jd-button :disabled="selectIds.length == 0 || isDrawTime" @click="batchAuditReject">批量审核拒绝</jd-button>
        <jd-button v-if="rankedOpenType == 1"  :disabled="selectIds.length == 0 || isDrawTime" @click="markWinning({}, true)">批量标记中奖</jd-button>
        <!-- <jd-button @click="isShowStatic = true">问卷统计</jd-button> -->
      </div>
      <jd-button type="text" @click="exportAll">导出</jd-button>
    </div>
    <jd-table @changeTableSort="changeTableSort" rowKey="id"  @handleSelectionChange="handleSelectionChange" selection v-loading="loading" :tableData="tableData" :pageInfo="{
      pageNum: formList.current,
      pageSize: formList.size,
      total: total,
    }" @handlePage="handlePage">
      <el-table-column prop="chaosPin" label="Pin"></el-table-column>
      <el-table-column prop="memberNick" label="用户昵称" width="150"></el-table-column>
      <el-table-column prop="sellerLinkName" label="投放渠道" width="150"></el-table-column>
      <el-table-column prop="submitTime" label="提交时间" width="155"></el-table-column>
      <el-table-column prop="commentId" label="评价id" width="150"></el-table-column>

      <el-table-column prop="orderId" label="关联订单号" width="150"></el-table-column>
      <el-table-column prop="orderItems" label="关联商品" width="200">
        <template slot-scope="scope">
          <div style="display: flex; align-items: center;">
            <div style="margin-right:8px">
              <img style="width: 60px; height: 60px;" :src="scope.row.mainUrl" alt="">
            </div>
            <div>
              <div style="width: 120px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{
                scope.row.orderItems }}</div>
              <div style="width: 120px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{
                scope.row.skuId }}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="commentStar" label="评价星级" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.commentStar == 1">一星</span>
          <span v-else-if="scope.row.commentStar == 2">二星</span>
          <span v-else-if="scope.row.commentStar == 3">三星</span>
          <span v-else-if="scope.row.commentStar == 4">四星</span>
          <span v-else-if="scope.row.commentStar == 5">五星</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="commentContent" label="评价内容" width="200"></el-table-column>
      <el-table-column prop="commentTime" label="评价时间" min-width="180"></el-table-column>
      <el-table-column prop="commentMedia" label="评价图片/视频" width="200">
        <template slot-scope="scope">
          <div class="flex flex-wrap">
            <div v-for="(item, index) in getImageList(scope.row.commentMedia)" :key="index">
              <el-image v-if="item.type === 'image'" :src="item.url"
                :preview-src-list="getImageList(scope.row.commentMedia).filter(i => i.type === 'image').map(i => i.url)"
                :initial-index="getImageList(scope.row.commentMedia).filter(i => i.type === 'image').findIndex(i => i.url === item.url)"
                class="mr4 mb4" style="width: 90px; height: 90px;" fit="cover"></el-image>
              <video v-else :src="item.url" class="mr4 mb4" style="width: 90px; height: 90px;"
                @click="openVideo(item.url)" controls></video>
                <span v-if="index < getImageList(scope.row.commentMedia).length - 1">,</span>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="receiverName" label="收件人" width="150">
        <template slot-scope="scope">
          <div class="open">
            {{ scope.row.receiverName }}
            <div class="openHover" v-if="
              scope.row.receiverName &&
              scope.row.receiverName.indexOf('*') != -1
            " @click="
              handleDecrypt(
                'receiverName',
                'tableData',
                scope.row,
                scope.$index
              )
              ">
              展开
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="receiverMobile" label="收件人手机号" width="150">
        <template slot-scope="scope">
          <div class="open">
            {{ scope.row.receiverMobile }}
            <div class="openHover" v-if="
              scope.row.receiverMobile &&
              scope.row.receiverMobile.indexOf('*') != -1
            " @click="
              handleDecrypt(
                'receiverMobile',
                'tableData',
                scope.row,
                scope.$index
              )
              ">
              展开
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="receiverAddress" label="收件人地区" width="150">
        <template slot-scope="scope">
          <div class="open">
            {{ scope.row.receiverAddress }}
            <div class="openHover" v-if="
              scope.row.receiverAddress &&
              scope.row.receiverAddress.indexOf('*') != -1
            " @click="
              handleDecrypt(
                'receiverAddress',
                'tableData',
                scope.row,
                scope.$index
              )
              ">
              展开
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="detailedAddress" label="收件人详细地址" width="200">
        <template slot-scope="scope">
          <div class="open">
            {{ scope.row.detailedAddress }}
            <div class="openHover" v-if="
              scope.row.detailedAddress &&
              scope.row.detailedAddress.indexOf('*') != -1
            " @click="
              handleDecrypt(
                'detailedAddress',
                'tableData',
                scope.row,
                scope.$index
              )
              ">
              展开
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="auditStatus" label="审核状态" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.auditStatus == 1">审核通过</span>
          <span v-else-if="scope.row.auditStatus == 2">审核拒绝
            {{ scope.row.auditReason }}
            <el-tooltip effect="dark" :content="scope.row.auditRemark" placement="top-start">
              <i class="new-icon-box ml4"></i>
            </el-tooltip>
          </span>
          <span v-else-if="scope.row.auditStatus == 0">待审核</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="auditTime" label="审核时间" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.auditTime ? scope.row.auditTime : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="likeCountDisplay" sortable label="点赞人数" width="150">
        <template slot-scope="scope">
          <jd-button @click="showOnlineUserDetails(scope.row.id)" type="blueText" size="mini"> {{
            scope.row.likeCountDisplay }}</jd-button>
        </template>
      </el-table-column>
      <el-table-column prop="rankDisplay" label="榜单排行" width="150">
        <template slot-scope="scope">
          {{ scope.row.rankDisplay }}
        </template>
      </el-table-column>
      <el-table-column prop="isWin" label="是否中奖" min-width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.isWin == 1">是</span>
          <span v-else-if="scope.row.isWin == 0">否</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column prop="isReceive" label="是否领奖" min-width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.isReceive == 1">是</span>
          <span v-else-if="scope.row.isReceive == 0">否</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="180">
        <template slot-scope="scope">
          <!-- :disabled="scope.row.auditStatus != 0" -->
          <jd-button type="blueText" :disabled="scope.row.auditStatus != 0"  size="mini" @click="reviewRow(scope.row)">审核</jd-button>
          <jd-button type="blueText" v-if="rankedOpenType == 1" :disabled="scope.row.isWin == 1 || isDrawTime || scope.row.isReceive == 1 || scope.row.auditStatus != 1" size="mini" @click="markWinning(scope.row)">
            标记中奖
          </jd-button>
        </template>
      </el-table-column>
      <!-- 动态列 -->
      <!-- <el-table-column
        v-for="question in dynamicColumns"
        :key="question"
        :label="question"
        width="220">
        <template #default="scope">
          <div
            @click="showImage(scope.row.answerVOList, question, $event)"
            v-html="getAnswer(scope.row.answerVOList, question)"></div>
        </template>
      </el-table-column> -->
    </jd-table>

    <div class="image-preview-container" v-if="showImageDialog">
      <div class="image-wrapper">
        <img :src="currentImageUrl" alt="预览图片" class="preview-image" />
        <div class="close-button" @click="showImageDialog = false">
          <i class="el-icon-close"></i>
        </div>
      </div>
    </div>

    <jd-dialog :visible.sync="isOpenVideo" @closed="closeVideo" width="750px" :isShowCancel="false" :isShowSure="false">
      <div style="text-align: center; min-width: 400px">
        <video v-if="isOpenVideo" ref="videoPlayer" :src="videoUrl" controls="controls"
          style="height: auto; width: 700px"></video>
      </div>
    </jd-dialog>

    <!-- 生成人群 -->
    <crowdDialog v-if="isShowCrowdDialog" :isShowCrowdDialog="isShowCrowdDialog"
      :searchForm="{ ...formList, ...sortFrom }" :activityType="82" :source="6" :defaultValue="hasDefaultValue"
      :defaultValueText="defaultValueText" @close="crowdClose" />

    <!-- 导出 -->
    <generate :control="openRemarkDialog" v-if="openRemarkDialog" @transData="(val) => (openRemarkDialog = val)"
      @transData1="confirmExport"></generate>

    <onlineUserDetails :show.sync="isShowStatic" :pkRecordId="pkRecordId"></onlineUserDetails>

    <jd-dialog :visible="isShowAudit" title="审核" width="1000px" :sureLoading="auditLoading" @comfirm="handleAudit"
      @close="isShowAudit = false">
      <el-descriptions title="" labelClassName="mt20" contentClassName="mt20">
        <el-descriptions-item label="Pin">
          {{ upvoteCountRow.chaosPin }}
        </el-descriptions-item>
        <el-descriptions-item label="用户昵称">
          {{ upvoteCountRow.memberNick }}
        </el-descriptions-item>
        <el-descriptions-item label="提交时间">
          {{ upvoteCountRow.submitTime }}
        </el-descriptions-item>
        <el-descriptions-item label="评价图片">
          <div class="flexc-cen-x" style="flex-wrap: wrap">
            <div v-for="(item, index) in getImageList(upvoteCountRow.commentMedia)" :key="index">
              <el-image v-if="item.type === 'image'" :src="item.url"
                :preview-src-list="getImageList(upvoteCountRow.commentMedia).filter(i => i.type === 'image').map(i => i.url)"
                :initial-index="getImageList(upvoteCountRow.commentMedia).filter(i => i.type === 'image').findIndex(i => i.url === item.url)"
                class="mr4 mb4" style="width: 90px; height: 90px;" fit="cover"></el-image>
            </div>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="评价视频">
          <div class="flexc-cen-x" style="flex-wrap: wrap">
            <div v-for="(item, index) in getImageList(upvoteCountRow.commentMedia)" :key="index">
              <video v-if="item.type === 'video'" :src="item.url" class="mr4 mb4" style="width: 90px; height: 90px;"
                @click="openVideo(item.url)" controls></video>
            </div>
          </div>
        </el-descriptions-item>

        <el-descriptions-item label="评价星级">
          <span v-if="upvoteCountRow.commentStar == 1">一星</span>
          <span v-else-if="upvoteCountRow.commentStar == 2">二星</span>
          <span v-else-if="upvoteCountRow.commentStar == 3">三星</span>
          <span v-else-if="upvoteCountRow.commentStar == 4">四星</span>
          <span v-else-if="upvoteCountRow.commentStar == 5">五星</span>
          <span v-else>-</span>
        </el-descriptions-item>
        <el-descriptions-item label="评价内容">
          {{ upvoteCountRow.commentContent }}
        </el-descriptions-item>
        <el-descriptions-item label="评价时间">
          {{ upvoteCountRow.commentTime }}
        </el-descriptions-item>
        <el-descriptions-item label="关联商品">
          <div style="display: flex; align-items: center;">
            <div style="margin-right:8px">
              <img style="width: 60px; height: 60px;" :src="upvoteCountRow.mainUrl" alt="">
            </div>
            <div>
              <div style="width: 120px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{
                upvoteCountRow.orderItems }}</div>
              <div style="width: 120px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{
                upvoteCountRow.skuId }}</div>
            </div>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="收货人">
          {{ upvoteCountRow.receiverName }}
        </el-descriptions-item>
        <el-descriptions-item label="收货人手机号">
          {{ upvoteCountRow.receiverMobile }}
        </el-descriptions-item>
        <el-descriptions-item label="收货地区">
          {{ upvoteCountRow.receiverAddress }}
        </el-descriptions-item>
        <el-descriptions-item label="收货人地址" :span="3">
          {{ upvoteCountRow.detailedAddress }}
        </el-descriptions-item>
        <el-descriptions-item label="审核结果" :span="3">
          <el-radio-group v-model="auditForm.auditStatus">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">拒绝</el-radio>
          </el-radio-group>
        </el-descriptions-item>
        <el-descriptions-item label="拒绝原因" :span="6" v-if="auditForm.auditStatus == '2'">
          <el-input type="textarea" style="width: 500px" show-word-limit :disabled="auditForm.auditStatus == '1'"
            resize="none" maxlength="100" :rows="4" v-model="auditForm.auditRemark"
            placeholder="请输入驳回原因，该内容将展示给用户，方便用户修改晒单后重新提交"></el-input>
        </el-descriptions-item>
      </el-descriptions>
    </jd-dialog>


    <jd-dialog
      :visible="isShowMarkWinning"
      title="标记中奖"
      width="800px"
      @comfirm="markWinSubmit"
      @close="isShowMarkWinning = false"
    >
      <tb-tip>
        <div style="margin-bottom: 8px;" v-if="isBatchWinning">
          已选中{{ selectIds.length }}条记录，其中可标记中奖记录{{
            selectIds.filter((item) => item.auditStatus == 1 && !item.isWin)
              .length
          }}条
        </div>
        <div>
          针对开奖方式为“商家手动审核开奖”有效，仅支持标记剩余库存大于0的奖品
        </div>
      </tb-tip>
      <el-form :model="markWinningForm.prizeId" class="mt20">
        <el-form-item label="中奖奖品" required>
          <el-select v-model="markWinningForm.prizeId" placeholder="请选择奖品">
            <el-option
              v-for="item in prizeList"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </jd-dialog>

    <jd-dialog
      :visible="isShowBatchAudit"
      :title="batchAuditType == 1 ? '批量审核通过' : '批量审核拒绝'"
      width="800px"
      @comfirm="batchAuditSubmit"
      @close="isShowBatchAudit = false"
    >
      <tb-tip>
        已选 {{ selectIds.length }} 条记录，其中可审批记录{{
          selectIds.filter((item) => item.auditStatus == 0).length
        }}
        条，
        {{
          batchAuditType == 1
            ? "审批通过后不可撤回，是否确定【批量审核通过】？"
            : "批量审核拒绝后不可撤回，是否确定【批量审核拒绝】？"
        }}
      </tb-tip>
      <el-form :model="batchAuditForm" class="mt20" v-if="batchAuditType == 2">
        <el-form-item label="拒绝原因" required>
          <el-input
            v-model="batchAuditForm.auditRemark"
            style="width: 320px"
            placeholder="请输入拒绝原因"
            type="textarea"
            :rows="4"
            show-word-limit
            :maxlength="100"
          ></el-input>
        </el-form-item>
      </el-form>
    </jd-dialog>
  </div>
</template>

<script>
import {
  exportPhotoContestRecord,
  getPhotoContestRecord,
  batchAudit,
  batchWinBatch,
} from "@/api/jhk/photoContestRecord.js";
import crowdDialog from "../crowd-Dialog.vue";
import statisticsData from "@/mixin/activity_statistics_new.js";
import onlineUserDetails from "./_components/onlineUserDetails.vue";
import {
  getShowImageGiftDetail
} from "@/api/jhk/integralCenter/PointActivityAnalyticController.js";
// import quesStatistics from "./_components/questionnaireStatistics.vue";

export default {
  mixins: [statisticsData],
  components: {
    crowdDialog,
    onlineUserDetails,
    // quesStatistics,
  },
  props: {
    activityId: {
      type: String,
      default: "",
    },
    channelList: {
      type: Array,
      default: () => [],
    },
    sellerLinkList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tableOpenAll: false,
      tableData: [],
      prizeList: [],
      total: 0,
      loading: false,
      dynamicColumns: [], // 题目
      showImageDialog: false,
      currentImageUrl: "",
      myFormInfo: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [], // 初始化为空数组
        },
        {
          label: "提交时间：",
          type: "DateRange",
          dateType: "submitTimeStart",
          startKey: "submitTimeEnd",
          endKey: "endTime",
          startPlaceholder: "选择日期时间",
          endPlaceholder: "选择日期时间",
          defalutLimit: true,
        },
        {
          label: "评价时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "commentTimeStart",
          endKey: "submitTimeEnd",
          startPlaceholder: "选择日期时间",
          endPlaceholder: "选择日期时间",
          defalutLimit: true,
        },
        {
          label: "审核状态：",
          prop: "auditStatus",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "待审核", value: 0 },
            { label: "审核通过", value: 1 },
            { label: "审核拒绝", value: 2 },
          ],
        },
        {
          label: "审核时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "auditTimeStart",
          endKey: "auditTimeEnd",
          startPlaceholder: "选择日期时间",
          endPlaceholder: "选择日期时间",
          defalutLimit: true,
        },
        {
          label: "订单号：",
          prop: "orderId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "评价ID：",
          prop: "commentId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "是否中奖：",
          prop: "isWin",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "是否领奖：",
          prop: "isReceive",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "评价星级：",
          prop: "commentStar",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "1星", value: 1 },
            { label: "2星", value: 2 },
            { label: "3星", value: 3 },
            { label: "4星", value: 4 },
            { label: "5星", value: 5 },
          ],
        },
      ],
      formList: {
        size: 10,
        current: 1,
        activityId: this.activityId,
      },
      sortFrom: {
        sortField: '',
        sortOrder: '',
      },
      isShowCrowdDialog: false, // 生成人群
      hasDefaultValue: false, // 是否有默认值
      defaultValueText: "", // 默认值文本
      openRemarkDialog: false, // 导出备注弹窗
      videoUrl: "", // 视频URL
      isOpenVideo: false, // 是否打开视频弹窗
      isShowStatic: false,
      pkRecordId: '', // 竞赛记录ID

      upvoteCountRow: {},
      auditForm: {},
      isShowAudit: false,
      isDrawTime: false,

      isBatchWinning: false,
      markWinningForm: {
        prizeId: "",
      },

      selectIds: [],
      isShowMarkWinning: false,

      isShowBatchAudit: false,
      batchAuditForm: {
        auditRemark: "",
      },
      batchAuditType: 1,
      rankedOpenType: 0,
    };
  },
  computed: {
    // 1: 京获客旗舰版
    softType() {
      return this.$store.getters.loginUserInfo.yunZhouOtherType || '';
    },
  },
  mounted() {
    this.updateSellerLinkOptions(); // 初始化时更新选项
    this.searchMethods();
    getShowImageGiftDetail(this.activityId).then(res=>{
      this.prizeList = res.data.pointActivityPrizeDTOList.filter(item => item.remanentAmount > 0) || [];
      const nowTime = new Date().getTime();
      const drawTime = new Date(
          res.data.ruleDto.rankedOpenTiming
      ).getTime();
      this.isDrawTime = drawTime && nowTime > drawTime ? true : false;
      this.rankedOpenType = res.data.ruleDto.rankedOpenType;
    })
  },
  watch: {
    // 监听sellerLinkList变化并更新表单选项
    sellerLinkList: {
      handler() {
        this.updateSellerLinkOptions();
      },
      deep: true
    }
  },
  methods: {
    batchAuditSubmit() {
      const ids = this.selectIds
        .filter((item) => item.auditStatus == 0)
        .map((item) => item.id);
      if (ids.length == 0) {
        this.$message.error("暂无可审批记录");
      } else if (
        this.batchAuditType == 2 &&
        !this.batchAuditForm.auditRemark
      ) {
        this.$message.error("请输入拒绝原因");
      } else if (this.isDrawTime) {
        this.$message.error("已到开奖时间，无法进行审核");
      } else {
        let data = {
          activityId: this.activityId,
          ids,
          auditStatus: this.batchAuditType,
        };
        if (this.batchAuditType == 2) {
          data.auditRemark = this.batchAuditForm.auditRemark;
        }
        this.batchAuditLoading = true;
        batchAudit(data)
          .then((res) => {
            this.batchAuditLoading = false;
            if (res.code == 1) {
              this.$message.success("审核成功");
              this.isShowBatchAudit = false;
              this.searchMethods();
            }else{
              this.$message.error(res.message);
            }
          })
          .catch((err) => {
            console.error(err);
            this.batchAuditLoading = false;
          });
      }
    },
    batchAuditPass() {
      this.batchAuditType = 1;
      this.isShowBatchAudit = true;
    },
    batchAuditReject() {
      this.batchAuditType = 2;
      this.batchAuditForm.auditRemark = "";
      this.isShowBatchAudit = true;
    },
    handleSelectionChange(val) {
      console.log(val);
      this.selectIds = [...val];
    },
    markWinSubmit(){
      let ids = this.isBatchWinning
        ? this.selectIds
            .filter((v) => v.auditStatus == 1 && !v.isWin)
            .map((item) => item.id)
        : [this.upvoteCountRow.id];
      if (this.isBatchWinning && ids.length == 0) {
        this.$message.error("暂无可标记记录");
      } else if (!this.markWinningForm.prizeId) {
        this.$message.error("请选择奖品");
      } else if (this.isDrawTime) {
        this.$message.error("已到开奖时间，无法操作");
      } else {
        let data = {
          activityId: this.activityId,
          ids,
          prizeId: this.markWinningForm.prizeId,
        };
        this.markWinLoading = true;
        batchWinBatch(data)
          .then((res) => {
            this.markWinLoading = false;
            if (res.code == 1) {
              this.isShowMarkWinning = false;
              this.$message.success("标记中奖成功");
              this.searchMethods();
            }else{
              this.$message.error(res.message);
            }
          })
          .catch((err) => {
            console.error(err);
            this.markWinLoading = false;
          });
      }
    },
    markWinning(row, isBatch) {
      if (isBatch == true) {
        this.isBatchWinning = true;
      } else {
        this.isBatchWinning = false;
      }
      this.isShowMarkWinning = true;
      this.markWinningForm.prizeId = "";
      this.upvoteCountRow = row;
    },
    handleAudit() {
      if (
        this.auditForm.auditRemark == "" &&
        this.auditForm.auditStatus == 2
      ) {
        this.$message.error("请输入拒绝原因");
        return;
      } else if (this.isDrawTime) {
        this.$message.error("已到开奖时间，无法进行审核");
        return;
      } else {
        this.auditLoading = true;
        batchAudit(this.auditForm)
          .then((res) => {
            this.auditLoading = false;
            if (res.code == 1) {
              this.$message.success("审核成功");
              this.isShowAudit = false;
              this.searchMethods();
            }else{
              this.$message.error(res.message);
            }
          })
          .catch((err) => {
            console.error(err);
            this.auditLoading = false;
          });
      }
    },
    reviewRow(row) {
      this.upvoteCountRow = row;
      this.auditForm = {
        ids: [row.id],
        auditStatus: 1,
        auditRemark: "",
        activityId: this.activityId,
      };
      this.isShowAudit = true;
    },
    // 显示在线用户详情
    showOnlineUserDetails(id) {
      this.pkRecordId = id;
      this.isShowStatic = true;
    },
    // 排序
    changeTableSort(sort) {
      console.log(sort);
      if (sort.order == 'ascending') {
        this.sortFrom.sortOrder = 'asc'
      } else if (sort.order == '"descending"') {
        this.sortFrom.sortOrder = 'des'
      }
      this.sortFrom.sortField = sort.prop
      this.searchMethods();
    },
    // 点击解密  name: 修改的字段名   objdata：数组的名称, params:接口的参数  item：点击的对象    index：数组传下标值
    handleDecrypt(name, objdata, item, index) {
      let params = "";
      // 资料明细 userInfoTable  实物奖品 inkindTable
      if (objdata == "userInfoTable") {
        params =
          "encrypt" + name[0].toUpperCase() + name.substring(1, name.length);
      } else if (objdata == "inkindTable" || objdata == "awardTable") {
        params =
          "decrypt" + name[0].toUpperCase() + name.substring(1, name.length);
      } else if (objdata == "postOrderInfoTable") {
        let str = name.substring(5, name.length);
        params = str[0].toLowerCase() + str.substring(1, name.length);
      } else {
        params =
          "decrypt" + name[0].toUpperCase() + name.substring(1, name.length);
      }
      this.$decrypt
        .decryptJHK({ decryptContent: item[`${params}`] })
        .then((res) => {
          this[`${objdata}`][index][`${name}`] = res.message;
        });
    },
    closeVideo() {
      const videoElement = this.$refs.videoPlayer;
      if (videoElement) {
        videoElement.pause(); // 暂停播放
        videoElement.currentTime = 0; // 重置播放进度
        this.videoUrl = ""; // 清空视频地址
      }
      this.isOpenVideo = false; // 关闭视频弹窗
    },
    openVideo(url) {
      this.videoUrl = url;
      this.isOpenVideo = true;
    },
    getImageList(imageList) {
      if (!imageList) return [];
      let imgList = [];
      const videoExtensions = ['mp4', 'mov', 'avi', 'flv', 'wmv', 'mkv', 'webm', 'ogg'];
      let imgListStr = imageList.split(",");
      imgListStr.forEach((item) => {
        let trimmedItem = item.trim();
        if (!trimmedItem) return;
        let urlPath = trimmedItem.split("?")[0];
        let extension = urlPath.split(".").pop().toLowerCase();
        let itemObj = {
          type: videoExtensions.includes(extension) ? "video" : "image",
          url: trimmedItem,
        }
        imgList.push(itemObj);
      })
      return imgList
    },
    addCrowd() {
      // 如果版本为京获客旗舰版需要校验用户时候有该按钮权限
      if (this.softType == 1 && !this.$store.getters.isJhkPlatformSeller) {
        return this.$message.warning("您不满足使用该功能，请联系专属客服了解~")
      }
      this.hasDefaultValue = true;
      this.defaultValueText = "调查问卷-问卷调查记录-";
      this.isShowCrowdDialog = true;
    },
    crowdClose() {
      this.isShowCrowdDialog = false;
      // 关闭时重置
      if (this.hasDefaultValue) {
        this.hasDefaultValue = false;
        this.defaultValueText = "";
      }
    },
    exportAll() {
      this.openRemarkDialog = true;
    },
    confirmExport(exportRemark = "") {
      let obj = this.$refs.searchFormRef.getSearchForm();
      let params = {
        ...obj,
        activityId: this.activityId,
        current: 1,
        size: 9999999,
        exportRemark,
        ...this.sortFrom,
      };
      this.formLoading = true;
      exportPhotoContestRecord(params).then((res) => {
        this.formLoading = false;
      });
    },
    search(params, type) {
      this.formList = {
        size: 10,
        current: 1,
        ...params,
        memberNick: params.memberNick || "",
        pin: params.pin || "",
        ...this.sortFrom,
        activityId: this.activityId,
      };
      if (type == "reset") {
        this.formList = {
          size: 10,
          current: 1,
          activityId: this.activityId,
          ...this.sortFrom,
        };
        this.$refs.searchFormRef.reData();
      }
      this.searchMethods();
    },
    showImage(answerList, question, event) {
      const answer = answerList.find((item) => item.type === question);
      // 检查是否有内容
      if (!answer || !answer.content) {
        return;
      }
      // 找到被点击的元素
      let target = event.target;

      // 如果点击的是放大镜图标，找到对应的图片
      if (target.className === "el-icon-zoom-in") {
        target = target.closest(".image-container").querySelector("img");
      }
      // 确保点击的是图片元素或其容器
      if (target.tagName === "IMG") {
        // 从自定义属性中获取图片URL
        const imageUrl = target.getAttribute("data-url");

        if (imageUrl) {
          console.log("显示图片", imageUrl);
          this.currentImageUrl = imageUrl;
          this.showImageDialog = true;
        }
      } else if (target.classList.contains("image-overlay")) {
        // 如果点击的是遮罩层，找到对应的图片
        const img = target.parentElement.querySelector("img");
        if (img) {
          const imageUrl = img.getAttribute("data-url");
          if (imageUrl) {
            console.log("显示图片", imageUrl);
            this.currentImageUrl = imageUrl;
            this.showImageDialog = true;
          }
        }
      }
    },

    handleCurrent(val) {
      this.formList.current = val;
      this.searchMethods();
    },

    handleSize(val) {
      this.formList.size = val;
      this.formList.current = 1;
      this.searchMethods();
    },
    handlePage(pageInfo) {
      this.formList.size = pageInfo.pageSize;
      this.formList.current = pageInfo.pageNum;
      this.searchMethods();
    },
    // 更新投放渠道下拉选项
    updateSellerLinkOptions() {
      const sellerLinkField = this.myFormInfo.find(item => item.prop === 'sellerLinkId');
      if (sellerLinkField && this.sellerLinkList && this.sellerLinkList.length > 0) {
        sellerLinkField.options = this.sellerLinkList.map(item => ({
          label: item.sellerLinkName,
          value: item.id
        }));
      }
    },

    searchMethods() {
      this.loading = true;
      getPhotoContestRecord({ ...this.formList })
        .then((res) => {
          if (res.code == 1) {
            this.tableData = res.data.records;
            this.total = Number(res.data.total);
            // 提取所有可能的题目类型
            // const allQuestions = new Set();
            // this.tableData.forEach((item) => {
            //   item.answerVOList.forEach((answer) => {
            //     allQuestions.add(answer.type);
            //   });
            // });
            // this.dynamicColumns = Array.from(allQuestions);
          } else {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.image-preview-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* 添加渐显渐隐效果 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.image-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: zoom-in 0.3s ease;
}

@keyframes zoom-in {
  from {
    transform: scale(0.8);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

.preview-image {
  max-width: 80%;
  max-height: 80vh;
  object-fit: contain;
}

.close-button {
  position: absolute;
  bottom: -50px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
}

.close-button i {
  font-size: 20px;
  color: #333;
}

.close-button:hover {
  background-color: rgba(255, 255, 255, 1);
}
</style>
